import { SVGProps } from 'react';
const SvgCheckAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m8 12.485 4.243 4.243 8.485-8.485M3 12.485l4.243 4.243M12.5 11.5l3.228-3.257"
    />
  </svg>
);
export default SvgCheckAll;
